module.exports = __webpack_public_path__ + "static/media/ticket-reserva.399b709b.svg";